//  @函数: 引入组件
export const lazyLoadingCop = file => require('@/views/' + file + '.vue').default

export const localSave = (key, value) => {
    localStorage.setItem(key, value)
  }
  
export const localRead = (key) => {
    return localStorage.getItem(key) || ''
  }
export const localRemove = (key) => {
    return localStorage.removeItem(key) || ''
  }
export const getQueryString =(name) => {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = decodeURI(window.location.search.substr(1)).match(reg);
    if (r != null)return unescape(r[2]);
    return null;
  }